<page-heading
  [title]="'report.leadSourceReport.title' | translate"
  [description]="'report.leadSourceReport.description' | translate"
  [hasBreadcrumb]="true"
  [breadcrumb]="breadcrumb"
/>

<div class="row">
  <div class="col-12">
    <div class="card">
      <div class="card-body">
        <form [formGroup]="formGroup">
          <div class="row g-2">
            <div class="col-xs-12 col-lg-7 input-trend-search">
              <input
                type="search"
                #searchBox
                class="form-control"
                [placeholder]="'report.leadSourceReport.searchPlaceholder' | translate"
                (keyup)="search(searchBox.value)"
              />
              <span class="mdi mdi-magnify search-icon ml-2"></span>
            </div>
            <div class="col-xs-12 col-lg-3 trend-datepicker">
              <mat-date-range-input
                [rangePicker]="picker"
                formGroupName="dateRange"
              >
                <input
                  matStartDate
                  [placeholder]="'report.leadSourceReport.startDate' | translate"
                  formControlName="dateStart"
                />
                <input
                  matEndDate
                  [placeholder]="'report.leadSourceReport.endDate' | translate"
                  formControlName="dateEnd"
                />
              </mat-date-range-input>
              <mat-datepicker-toggle matIconSuffix [for]="picker" />
              <mat-date-range-picker #picker>
                <mat-datepicker-actions>
                  <mat-select
                    class="input-field rounded-lg"
                    [placeholder]="'report.leadSourceReport.select' | translate"
                    (selectionChange)="onPeriodChange($event)"
                  >
                    <mat-option value="1">{{ 'report.leadSourceReport.today' | translate }}</mat-option>
                    <mat-option value="7">{{ 'report.leadSourceReport.last7Days' | translate }}</mat-option>
                    <mat-option value="15">{{ 'report.leadSourceReport.last15Days' | translate }}</mat-option>
                    <mat-option value="30">{{ 'report.leadSourceReport.last30Days' | translate }}</mat-option>
                    <mat-option value="60">{{ 'report.leadSourceReport.last60Days' | translate }}</mat-option>
                  </mat-select>
                  <button mat-raised-button matDatepickerApply class="btnOk">
                    OK
                  </button>
                </mat-datepicker-actions>
              </mat-date-range-picker>
            </div>

            <div class="col-xs-6 col-md-6 col-xl-2 gap-2 btn-group">
              <button
                class="btn btn-primary fw-bold"
                [matTooltip]="'report.leadSourceReport.exportToExcel' | translate"
                [disabled]="isLoading"
                (click)="exportToExcel()"
              >
                @if (isLoading) {
                  <mat-spinner
                    [diameter]="25"
                    mode="indeterminate"
                  ></mat-spinner>
                } @else {
                  <i class="ri-file-text-line"></i>
                }
              </button>

              <button
                class="btn btn-primary fw-bold"
                [matTooltip]="'report.leadSourceReport.exportToPdf' | translate"
                [disabled]="isLoading"
                (click)="exportToPDF()"
              >
                @if (isLoading) {
                  <mat-spinner
                    [diameter]="25"
                    mode="indeterminate"
                  ></mat-spinner>
                } @else {
                  <i class="ri-share-box-fill"></i>
                }
              </button>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</div>

@if (result) {
  <div class="row mb-3 g-2">
    <div class="col-xs-12 col-lg-3">
      <div class="card h-100">
        <div class="card-body d-flex flex-column justify-content-between">
          <br />
          <h3 class="mb-1">{{ result.kpis.totalAttendances }}</h3>
          <p class="text-muted fw-normal mb-0 text-truncate">
            {{ 'report.leadSourceReport.totalAttendances' | translate }}
          </p>
        </div>
      </div>
    </div>

    <div class="col-xs-12 col-lg-3">
      <div class="card h-100">
        <div class="card-body d-flex flex-column justify-content-between">
          <span class="mb-0 font-18 fw-bold">
            {{ result.kpis.withLeadSource.count }}
          </span>
          <h3 class="mb-1">{{ result.kpis.withLeadSource.percent }}%</h3>
          <p class="text-muted fw-normal mb-0 text-truncate">
            {{ 'report.leadSourceReport.withIdentifiedSource' | translate }}
          </p>
        </div>
      </div>
    </div>

    <div class="col-xs-12 col-lg-3">
      <div class="card h-100">
        <div class="card-body d-flex flex-column justify-content-between">
          <p class="mb-1 font-18 fw-bold">
            {{ result.kpis.topConversionSource.name }}
          </p>
          <h3 class="mb-1">
            {{ result.kpis.topConversionSource.conversionRate }}%
          </h3>
          <p class="text-muted fw-normal mb-0 text-truncate">
            {{ 'report.leadSourceReport.topConversionSource' | translate }}
          </p>
        </div>
      </div>
    </div>

    <div class="col-xs-12 col-lg-3">
      <div class="card h-100">
        <div class="card-body d-flex flex-column justify-content-between">
          <p class="mb-0 font-18 fw-bold">
            {{ result.kpis.topVolumeSource.name }}
          </p>
          <h3 class="mb-1">
            {{ result.kpis.topVolumeSource.totalAttendances }}
          </h3>
          <p class="text-muted fw-normal mb-0 text-truncate">
            {{ 'report.leadSourceReport.topVolumeSource' | translate }}
          </p>
        </div>
      </div>
    </div>
  </div>
}

@if (result?.allLeadSources?.length) {
  <div class="row mb-3">
    <div class="col-xs-12 col-lg-8">
      <div class="card h-100">
        <div class="card-body">
          <h5 class="fw-semibold mb-1">{{ 'report.leadSourceReport.conversionRateBySource' | translate }}</h5>
          <small class="text-muted">
            {{ 'report.leadSourceReport.conversionRateBySourceSubtitle' | translate }}
          </small>
          <div
            class="mt-3"
            style="position: relative; height: 220px; max-height: 220px"
          >
            <canvas #chartConversionRate></canvas>
          </div>
        </div>
      </div>
    </div>
    <div class="col-xs-12 col-lg-4">
      <div class="card h-100">
        <div class="card-body">
          <h5 class="fw-semibold mb-1">{{ 'report.leadSourceReport.distributionBySource' | translate }}</h5>
          <small class="text-muted">{{ 'report.leadSourceReport.distributionBySourceSubtitle' | translate }}</small>
          <div class="mt-3" style="position: relative; max-height: 220px">
            <canvas #chartDistributionByLeadSource></canvas>
          </div>
        </div>
      </div>
    </div>
  </div>
}

<div class="row">
  <div class="col-12">
    <div class="card">
      <h4 class="card-header d-flex flex-column gap-2">
        {{ 'report.leadSourceReport.conversionsBySource' | translate }}
        <small class="text-muted">
          {{ 'report.leadSourceReport.conversionsBySourceSubtitle' | translate }}
        </small>
      </h4>

      <div class="card-body table-responsive">
        <table class="table table-hover table-centered mb-0">
          <thead>
            <tr>
              <th class="text-primary-emphasis">{{ 'report.leadSourceReport.tableSource' | translate }}</th>
              <th class="text-primary-emphasis">{{ 'report.leadSourceReport.tableTotal' | translate }}</th>
              <th class="text-primary-emphasis">{{ 'report.leadSourceReport.tableClosed' | translate }}</th>
              <th class="text-primary-emphasis">{{ 'report.leadSourceReport.tableConversionRate' | translate }}</th>
            </tr>
          </thead>
          <tbody>
            @for (item of result?.allLeadSources; track $index) {
              <tr>
                <td>
                  <span>
                    {{ item.leadSourceName }}
                  </span>
                </td>
                <td>
                  <span>
                    {{ item.totalAttendances }}
                  </span>
                </td>
                <td>
                  <span>
                    {{ item.wonAttendances }}
                  </span>
                </td>
                <td>
                  <span
                    class="badge px-1 font-12"
                    [ngClass]="{
                      'bg-danger': item.conversionRate < 10,
                      'bg-info':
                        item.conversionRate >= 11 && item.conversionRate <= 50,
                      'bg-success': item.conversionRate > 50,
                    }"
                  >
                    {{ item.conversionRate }}%
                  </span>
                </td>
              </tr>
            }
          </tbody>
        </table>
      </div>
    </div>
  </div>
</div>

<div class="row">
  <div class="col-12">
    <div class="card">
      <h4 class="card-header d-flex flex-column gap-2">
        {{ 'report.leadSourceReport.attendancesList' | translate }}
        <small class="text-muted">
          {{ 'report.leadSourceReport.attendancesListSubtitle' | translate }}
        </small>
      </h4>
      @if (loadingContent) {
        <content-loading-list />
      }

      @if (!loadingContent && pager.total === 0) {
        <empty-records-component
          [message]="'report.leadSourceReport.emptyMessage' | translate"
          [subMessage]="'report.leadSourceReport.emptySubMessage' | translate"
          [icon]="'mdi mdi-alert-circle-outline'"
        />
      }

      @if (!loadingContent && pager.total > 0) {
        <div class="card-body table-responsive">
          <table class="table table-hover table-centered mb-0">
            <thead>
              <tr>
                <th class="text-primary-emphasis">{{ 'report.leadSourceReport.tableName' | translate }}</th>
                <th class="text-primary-emphasis">{{ 'report.leadSourceReport.tablePhone' | translate }}</th>
                <th class="text-primary-emphasis">{{ 'report.leadSourceReport.tableSource' | translate }}</th>
                <th class="text-primary-emphasis">{{ 'report.leadSourceReport.tableAgent' | translate }}</th>
                <th class="text-primary-emphasis">{{ 'report.leadSourceReport.tableStatus' | translate }}</th>
                <th class="text-primary-emphasis">{{ 'report.leadSourceReport.tableStart' | translate }}</th>
              </tr>
            </thead>
            <tbody>
              @for (item of pager.list; track item) {
                <tr>
                  <td>
                    <span>
                      @if (item?.contact?.name?.length > 15) {
                        <span matTooltip="{{ item?.contact?.name }}">
                          {{ $safeNavigationMigration(item?.contact?.name) | truncate: 15 }}
                        </span>
                      } @else {
                        <span>
                          {{ item?.contact?.name }}
                        </span>
                      }
                    </span>
                  </td>
                  <td>
                    <span>
                      {{ item?.contact?.phone }}
                    </span>
                  </td>

                  <td>
                    <span>
                      {{ $any(item)?.leadSource?.name ?? "-" }}
                    </span>
                  </td>
                  <td>
                    @if (!!$any($safeNavigationMigration(item?.user))?.[0]?.name) {
                      @if ($any($safeNavigationMigration(item?.user))?.[0]?.name?.length > 10) {
                        <span matTooltip="{{ $any($safeNavigationMigration(item?.user))?.[0]?.name }}">
                          {{ $safeNavigationMigration($any($safeNavigationMigration(item?.user))?.[0]?.name) | truncate: 10 }}
                        </span>
                      }
                      @if ($any($safeNavigationMigration(item?.user))?.[0]?.name?.length <= 10) {
                        <span>
                          {{ $any($safeNavigationMigration(item?.user))?.[0]?.name }}
                        </span>
                      }
                    } @else {
                      <span>-</span>
                    }
                  </td>
                  <td class="position-relative">
                    <div class="d-flex flex-column gap-1">
                      <span
                        class="badge text-capitalize font-14"
                        [ngClass]="{
                          'bg-success': item?.status === 'IN_PROGRESS',
                          'bg-warning': item?.status === 'PENDING',
                          'bg-danger': item?.status === 'OVERTIME',
                          'bg-primary': item?.status === 'PAUSED',
                          'bg-secondary': item?.status === 'CLOSED',
                        }"
                      >
                        {{ translateStatus($safeNavigationMigration(item?.status)) }}
                      </span>
                      @if (
                        item?.status === "PENDING" &&
                        item?.chatbotStatus?.automated
                      ) {
                        <span
                          class="badge bg-dark p-1 rounded-pill badge-position translate-middle"
                          [matTooltip]="'report.leadSourceReport.chatbotStartedTooltip' | translate"
                        >
                          <i class="mdi mdi-robot"></i>
                        </span>
                      }
                    </div>
                  </td>
                  <td>
                    <span>
                      {{
                        item.createdAt
                          | timezoneDate
                            : "DD/MM/YYYY HH:mm"
                            : getTimezoneCompanyCurrentUser()
                      }}
                    </span>
                  </td>
                </tr>
              }
            </tbody>
          </table>

          @if (pager.total > pager.perPage) {
            <paginator [pager]="pager" (onPager)="loadPage($event)"></paginator>
          }
        </div>
      }
    </div>
  </div>
</div>
